import React from 'react';
import styled from 'styled-components';
import { DrawerSummaryItem } from 'common/drawer/SummaryItemView';
import { RateCardModel } from '@utmost.co/enterprise-models';
import LocationDetails from 'src/components/pages/settings/Engagements/RateCards/drawer/LocationDetails';
import RemoteWorkAddressDetails from 'src/components/pages/settings/Engagements/RateCards/drawer/RemoteWorkAddressDetails';
import SupplierDetails from 'src/components/pages/settings/Engagements/RateCards/drawer/SupplierDetails';
import { useRateCardsIntl } from '../translations/useRateCardsIntl';
import SectionLabel from './SectionLabel';

interface Props {
  rateCard?: RateCardModel;
}

export const DetailsSummary: React.FC<React.PropsWithChildren<Props>> = ({ rateCard }) => {
  const intl = useRateCardsIntl();

  return (
    <div data-test="drawer-summary">
      <SectionLabel>{intl.summary}</SectionLabel>
      <StyledDiv data-test="summary-items-container">
        <DrawerSummaryItem label={intl.name} loading={false} dataTest="name-item">
          {rateCard?.name}
        </DrawerSummaryItem>
        <DrawerSummaryItem label={intl.referenceCode} loading={false} dataTest="ref-code-item">
          {rateCard?.referenceCode}
        </DrawerSummaryItem>
        <DrawerSummaryItem label={intl.jobProfile} loading={false} dataTest="job-profile-item">
          {rateCard?.jobProfile?.name}
        </DrawerSummaryItem>
        <DrawerSummaryItem label={intl.location} loading={false} dataTest="location-item">
          <LocationDetails rateCard={rateCard} />
        </DrawerSummaryItem>
        <DrawerSummaryItem label={intl.remoteWorkAddress} loading={false} dataTest="remote-work-location-item">
          <RemoteWorkAddressDetails rateCard={rateCard} />
        </DrawerSummaryItem>
        <DrawerSummaryItem label={intl.supplier} loading={false} dataTest="supplier-item">
          <SupplierDetails supplier={rateCard?.supplier} />
        </DrawerSummaryItem>
      </StyledDiv>
    </div>
  );
};

const StyledDiv = styled.div`
  width: 33rem;
`;
